import type { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import classNames from "classnames";

export interface StatItem {
    key: string;
    label: string; // Read by screen readers (the icon alone says nothing)
    value: ReactNode;
    icon: IconDefinition;
}

interface StatBarProps {
    items: StatItem[];
    className?: string; // Callers add display classes ("flex", "hidden lg:flex")
}

// Equal-width cells separated by borders
const StatBar = ({ items, className }: StatBarProps) => {
    return (
        <div
            className={classNames(
                "w-full border-2 border-gray-200 text-lg font-bold rounded-md bg-gray-100 items-center",
                className
            )}
        >
            {items.map((item, index) => (
                <div
                    key={item.key}
                    title={item.label}
                    className={classNames(
                        "flex-1 flex justify-center items-center gap-x-3 border-gray-200 p-5",
                        // border-e is the side facing the next cell, in both RTL and LTR
                        index < items.length - 1 && "border-e-2"
                    )}
                >
                    <span className="sr-only">{item.label}</span>
                    <span>{item.value}</span>
                    <FontAwesomeIcon icon={item.icon} aria-hidden="true" />
                </div>
            ))}
        </div>
    );
};

export default StatBar;